export enum OrderTachographActionReason {
  DRIVING = 'driving',
  WAITING_FOR_SERVICE = 'waiting-for-service',
  SHORT_BREAK = 'short-break',
  DAILY_BREAK = 'daily-break',
  WEEK_LIMIT_REACHED = 'week-limit-reached',
  WEEK_CYCLE_FINISHED = 'week-cycle-finished',
  OTHER_WORK = 'other-work',
}
